<template>
  <BittsLayout :is-page="true">
    <template #content>
      <PageTitle title="My Team" />
      <TeamCounter />
      <TeamTablesWrapper />
      <router-view-wrapper />
      <!-- Invite Modal -->
    </template>
  </BittsLayout>
</template>

<script setup>
import { BittsLayout } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';

import PageTitle from '@/components/PageTitle.vue';
import TeamCounter from '@/components/team/TeamCounter.vue';
import TeamTablesWrapper from '@/components/team/TeamTablesWrapper.vue';

useHead({ title: 'Team - Crossbeam' });
</script>
